import { useCallback } from 'react';

import { useAuthStore } from 'src/auth/store/auth.store';

import { isValidToken, setSession, getStoredTokens } from '../utils/utils';

export const useAuth = () => {
  const { setIsAuthenticated, setLoading, refreshAccessToken } = useAuthStore();

  const initializeAuth = useCallback(async () => {
    try {
      setLoading(true);

      const { accessToken, refreshToken } = getStoredTokens();

      if (accessToken && isValidToken(accessToken)) {
        // If access token is valid, log in the user
        setSession(accessToken, refreshToken);
        setIsAuthenticated(true);
      } else if (refreshToken && isValidToken(refreshToken)) {
        // If refresh token is valid, try to refresh access token
        try {
          const newAccessToken = await refreshAccessToken();
          if (newAccessToken && isValidToken(newAccessToken)) {
            // If new access token is obtained, set authenticated state
            setIsAuthenticated(true);
          } else {
            // If no valid tokens, clear session and set unauthenticated state
            setSession(null, null);
            setIsAuthenticated(false);
          }
        } catch (error) {
          console.error('Failed to refresh token:', error);
          // Não mostra snackbar na inicialização, apenas limpa a sessão
          setSession(null, null);
          setIsAuthenticated(false);
        }
      } else {
        // If no valid tokens, set unauthenticated state
        setSession(null, null);
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Auth initialization failed:', error);
      setSession(null, null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }, [setIsAuthenticated, setLoading, refreshAccessToken]);

  return {
    initializeAuth,
  };
};
